import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "redux/actions/importActions";
import { Translate, I18n } from "react-redux-i18n";
import alertify from 'alertifyjs';
import { parseCsv, filterTastytradeRows } from 'utils/parseCsv';

// const useStyles = {
//     root: {},
//     row: {
//         height: "42px",
//         display: "flex",
//         alignItems: "center",
//         marginTop: theme.spacing(1),
//     },
//     spacer: {
//         flexGrow: 1,
//     },
//     importButton: {
//         marginRight: theme.spacing(1),
//     },
//     exportButton: {
//         marginRight: theme.spacing(1),
//     },
//     searchInput: {
//         marginRight: theme.spacing(1),
//     },
// };

const Toolbar = (props) => {
    const { className, history, ...rest } = props;

    const onClickFileIn = () => {
        history.push("/file/in");
    };

    const onClickFolderIn = () => {
        history.push("/folder/in");
    };

    const [values, setValues] = useState({ broker: 'tastyworks' });
    const [file, setFile] = useState();

    const handleChange = event => {
        event.persist();
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });
    };

    const csvToTable = (str) => {
        const { header, rows } = parseCsv(str);
        const filtered = filterTastytradeRows(rows);
        props.setTableCsv({ header, list: filtered });
        return filtered.length;
    };

    const onClickImport = () => {
        if (!file) {
            alertify.error(I18n.t('import_select_file'));
            return;
        }
        const reader = new FileReader();
        reader.onload = (event) => {
            const count = csvToTable(event.target.result);
            if (count > 0) {
                alertify.success(I18n.t('import_preview_ready', { count }));
            } else {
                alertify.error(I18n.t('import_no_rows'));
            }
        };
        reader.readAsText(file);
    };

    const onClickSave = async () => {
        if (!props.list || props.list.length === 0) {
            alertify.error(I18n.t('import_load_first'));
            return;
        }
        if (!values.broker || values.broker === '0') {
            alertify.error(I18n.t('import_select_broker'));
            return;
        }
        await props.newList(
            {
                id: props.user_id,
                header: props.header,
                list: props.list,
                broker: values.broker,
            },
            props.token
        );
    };

    const onChange = (e) => {
        setFile(e.target.files[0]);
        /*
          let reader = new FileReader();
          if (e.target.files[0]) {
              reader.onload = function (e) {
                  const data = e.target.result;
                  csvToTable(data);
              }
              reader.readAsText(file);
          }
          */
    }

    const option_broker = [
        { value: "tastyworks", label: "Tastytrade" },
        { value: "tastytrade", label: "Tastytrade (OAuth)" },
    ];

    return (
            <div className={''} style={{display: 'flex', flexDirection: 'row'}}>
                <select
                    margin="dense"
                    id="broker"
                    name="broker"
                    required="true"
                    label="Kind broker"
                    type="text"
                    onChange={handleChange}
                    // fullWidth
                    variant="standard"
                    value={values.broker || 'tastyworks'}
                    // select
                >
                    <option key={"0"} value={"0"}>
                        {"Select Broker"}
                    </option>
                    {option_broker.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
                   
                    

                <input type={"file"} accept={".csv"} id={"file"} onChange={onChange} />
                <span className={''} />
                <button
                    className={'btn btn-secondary'}
                    onClick={onClickImport}>
                    <Translate value="upload" />
                </button>
                <button
                    className={'btn btn-primary'}
                    onClick={onClickSave}>
                    <Translate value="save" />
                </button>
            </div>
    );
};

Toolbar.propTypes = {
    className: PropTypes.string,
    history: PropTypes.object
};


function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        list: reducer.import_.list,
        header: reducer.import_.header,
    };
}
const mapDispatchToProps = dispatch => ({
    setTableCsv: (data) =>
        dispatch(actions.setTableCSV(data)),
    newList: (params, token) =>
        dispatch(actions.newList({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar);

/**
 *  <div className={classes.row}>
                <span className={classes.spacer} />
                <Button className={classes.importButton}>Import</Button>
                <Button className={classes.exportButton}>Export</Button>
                <Button color="secondary" variant="outlined" onClick={onClickFolderIn}>
                    Crear Carpeta
                </Button>
                <Button color="primary" variant="contained" onClick={onClickFileIn}>
                    Agregar Archivo
                </Button>
            </div>
 */